
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0657"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0657"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jI3uq", function(module, exports) {
module.exports = JSON.parse("{\"title\":\"Between\",\"description\":\"I always thought that Bedfordshire was similar to the Far West.\",\"gallery\":[{\"caption\":\"The way to go\",\"location\":\"Leighton Buzzard, Bedfordshire\",\"image\":\"thewaytogo\"},{\"caption\":\"Bus Stop\",\"location\":\"Leighton Buzzard, Bedfordshire\",\"image\":\"busstop\"},{\"caption\":\"Chalk\",\"location\":\"Bedfordshire\",\"image\":\"chalk\"},{\"caption\":\"House\",\"location\":\"Leighton Buzzard, Bedfordshire\",\"image\":\"house\"},{\"caption\":\"Searching\",\"location\":\"Leighton Buzzard, Bedfordshire\",\"image\":\"searching\"},{\"caption\":\"Train tracks\",\"location\":\"Leighton Buzzard, Bedfordshire\",\"image\":\"traintracks\"},{\"caption\":\"Yellow door\",\"location\":\"Leighton Buzzard, Bedfordshire\",\"image\":\"yellowdoor\"},{\"caption\":\"Big and Small\",\"location\":\"Leighton Buzzard, Bedfordshire\",\"image\":\"bigsmall\"}]}");

});

parcelRegister("4ojXC", function(module, exports) {
module.exports = JSON.parse("{\"title\":\"Donde vas\",\"description\":\"Peru, November 2019\",\"gallery\":[{\"caption\":\"Musica\",\"location\":\"Puno, Peru\",\"image\":\"musica\"},{\"caption\":\"Mujer\",\"location\":\"Puno, Peru\",\"image\":\"mujer\"},{\"caption\":\"Titicaca\",\"location\":\"Puno, Peru\",\"image\":\"titicaca\"},{\"caption\":\"Lago\",\"location\":\"Puno, Peru\",\"image\":\"lago\"},{\"caption\":\"La Raya\",\"location\":\"Between Puno and Cusco, Peru\",\"image\":\"laraya\"},{\"caption\":\"Donde vas\",\"location\":\"Between Puno and Cusco, Peru\",\"image\":\"dondevas\"},{\"caption\":\"Machu Picchu\",\"location\":\"Machu Picchu, Cusco region, Peru\",\"image\":\"machupicchu\"},{\"caption\":\"Periquito\",\"location\":\"Pilcopata, Cusco Region, Peru\",\"image\":\"pappagallo\"},{\"caption\":\"Buen dia\",\"location\":\"Atalaya, Madre de Dios region, Peru\",\"image\":\"buendia\"},{\"caption\":\"Good night\",\"location\":\"Pilcopata, Cusco Region, Peru\",\"image\":\"goodnight\"}]}");

});

parcelRegister("gkAa9", function(module, exports) {
module.exports = JSON.parse("{\"title\":\"Zdrowie\",\"description\":\"Around Krakow, just before the COVID-19 lockdown started, March 2020\",\"gallery\":[{\"caption\":\"Golden Windows\",\"location\":\"Krakow, Poland\",\"image\":\"goldenwindows\"},{\"caption\":\"Horse\",\"location\":\"Krakow, Poland\",\"image\":\"horse\"},{\"caption\":\"Ghetto Heroes Square\",\"location\":\"Krakow, Poland\",\"image\":\"ghettoheroessquare\"},{\"caption\":\"Happy Again\",\"location\":\"Krakow, Poland\",\"image\":\"happyagain\"},{\"caption\":\"Aushwitz\",\"location\":\"Aushwitz, Poland\",\"image\":\"aushwitz\"},{\"caption\":\"Wieliczka\",\"location\":\"Wieliczka Salt Mine, Poland\",\"image\":\"saltmine\"},{\"caption\":\"Night Reading\",\"location\":\"Krakow, Poland\",\"image\":\"nightreading\"},{\"caption\":\"Zdrowie\",\"location\":\"Krakow, Poland\",\"image\":\"zdrowie\"}]}");

});

parcelRegister("hOFCO", function(module, exports) {
module.exports = JSON.parse("{\"title\":\"Animals\",\"description\":\"Wildlife, not so wild life, creatures big and small\",\"gallery\":[{\"caption\":\"Sleeping pod\",\"location\":\"Acrylics\",\"image\":\"sleepingpod\"},{\"caption\":\"Mid morning snack\",\"location\":\"Gouache and pencils on paper\",\"image\":\"pelican\"},{\"caption\":\"Robin Redbreast\",\"location\":\"Markers and pencils on bristol paper\",\"image\":\"robinredbreast\"},{\"caption\":\"The most over-dramatic mating dance\",\"location\":\"Gouache and acrylics collage on canvas\",\"image\":\"overdrama\"},{\"caption\":\"El paraiso\",\"location\":\"Gouache\",\"image\":\"elparaiso\"},{\"caption\":\"Onsen Macaque\",\"location\":\"Pencil and markers on paper.\",\"image\":\"macaque\"}]}");

});

parcelRegister("gfs8c", function(module, exports) {
module.exports = JSON.parse("{\"title\":\"Landscape\",\"description\":\"More horizontal than portrait\",\"gallery\":[{\"caption\":\"Murmurations\",\"location\":\"Acrylics on paper\",\"image\":\"murmurations_small\"},{\"caption\":\"Shaftesbury avenue\",\"location\":\"Acrylics. After a workshop with Adebanji Alade\",\"image\":\"londonstride\"},{\"caption\":\"Oh the British Summer\",\"location\":\"Watercolour and pencils\",\"image\":\"ohbritishsummer\"},{\"caption\":\"Cairo\",\"location\":\"Watercolour and pencils\",\"image\":\"cairo\"},{\"caption\":\"Henley\",\"location\":\"Watercolour and oil pastels\",\"image\":\"henley\"}]}");

});

parcelRegister("a7vAJ", function(module, exports) {
module.exports = JSON.parse("{\"title\":\"Everything else\",\"description\":\"Not an animal or a landscape\",\"gallery\":[{\"caption\":\"Sunday morning\",\"location\":\"Gouache on paper\",\"image\":\"nonnas\"},{\"caption\":\"The reason why they don't let me redecorate the church\",\"location\":\"Acrylics.\",\"image\":\"church\"},{\"caption\":\"California Rusty\",\"location\":\"Acrylics\",\"image\":\"rusty_small\"},{\"caption\":\"Santa's sway\",\"location\":\"Ink\",\"image\":\"santasway\"},{\"caption\":\"XMAS Eve\",\"location\":\"Ink\",\"image\":\"xmaseve\"}]}");

});

let $777d0d94d01f7e7e$var$currentGallery = {};
let $777d0d94d01f7e7e$var$currentIndex = 0;
let $777d0d94d01f7e7e$var$galleryName = "";
window.gallery = {
    currentIndex: 0,
    galleryName: '',
    currentGallery: {},
    switchTo: function(index) {
        galleryImages = document.getElementsByClassName("profile-gallery--image");
        for(let i = 0; i < galleryImages.length; i++)if (i !== index) galleryImages[i].style.display = "none";
        else galleryImages[i].style.display = "block";
    },
    load: function(name) {
        this.currentGallery = window.galleries[name];
        this.galleryName = name;
        let galleryHtmls = [];
        for(let i = 0; i < this.currentGallery.gallery.length; i++){
            let galleryItem = this.currentGallery.gallery[i];
            let caption = galleryItem.caption;
            let location = galleryItem.location;
            let webp = "photoprojects/" + this.galleryName + "/" + galleryItem.image + ".webp";
            let jpg = "photoprojects/" + this.galleryName + "/" + galleryItem.image + ".jpg";
            galleryHtmls.push(`
        <div class="profile-gallery--image">
            <div class="profile-gallery--meta">
                <div class="profile-gallery--meta--caption">${caption}</div>
                <div  class="profile-gallery--meta--location">${location}</div>
            </div>
            <picture>
                <source  srcset="${webp}" type="image/webp">
                <source  srcset="${jpg}" type="image/jpg">
                <img  src="${jpg}"
                     alt=""/>
            </picture>
        </div>`);
        }
        document.getElementById("gallery-items").innerHTML = galleryHtmls.join("");
        this.show();
        this.switchTo(0);
        document.getElementById("profile-gallery--overlayprev").addEventListener("click", function() {
            window.gallery.prev();
        });
        document.getElementById("profile-gallery--overlaynext").addEventListener("click", function() {
            window.gallery.next();
        });
        document.addEventListener('keydown', function(event) {
            if (event.key === "ArrowRight") {
                event.stopImmediatePropagation();
                window.gallery.next();
                return false;
            }
            if (event.key === "ArrowLeft") {
                event.stopImmediatePropagation();
                window.gallery.prev();
                return false;
            }
            if (event.key === "Esc" || event.key === "Escape") {
                window.gallery.hide();
                return false;
            }
        });
    },
    next: function() {
        this.currentIndex = (this.currentIndex + 1) % this.currentGallery.gallery.length;
        window.gallery.switchTo(this.currentIndex);
    },
    prev: function() {
        this.currentIndex = (this.currentIndex - 1) % this.currentGallery.gallery.length;
        if (this.currentIndex < 0) this.currentIndex = this.currentGallery.gallery.length - 1;
        this.switchTo(this.currentIndex);
    },
    open: function(name) {
        window.showGallery = true;
        this.load(name);
    },
    show: function() {
        document.getElementById("gallery").classList.remove("disappear");
        document.getElementById("gallery").classList.add("appear");
        document.getElementById("profile-gallery--overlayprev").style.display = "block";
        document.getElementById("profile-gallery--overlaynext").style.display = "block";
        document.getElementById("gallery-prev").style.display = "block";
        document.getElementById("gallery-next").style.display = "block";
        document.getElementById("gallery-close").style.display = "block";
        window.scrollToElement(document.getElementById("gallery"));
    },
    hide: function() {
        document.getElementById("gallery").classList.remove("appear");
        document.getElementById("gallery").classList.add("disappear");
        document.getElementById("profile-gallery--overlayprev").style.display = "none";
        document.getElementById("profile-gallery--overlaynext").style.display = "none";
        document.getElementById("gallery-prev").style.display = "none";
        document.getElementById("gallery-next").style.display = "none";
        document.getElementById("gallery-close").style.display = "none";
        window.scrollToElement(document.getElementById("profile-artist-galleries"));
    }
};



let $1196adbed9371d3e$var$new_scroll_position = 0;
let $1196adbed9371d3e$var$last_scroll_position;
let $1196adbed9371d3e$var$header = document.getElementById("bar");
window.showGallery = false;
function $1196adbed9371d3e$var$showHideBar(e) {
    $1196adbed9371d3e$var$last_scroll_position = window.scrollY;
    // Scrolling down
    if ($1196adbed9371d3e$var$last_scroll_position < 400) {
        // header.removeClass('slideDown').addClass('slideUp');
        $1196adbed9371d3e$var$header.classList.remove("slideDown");
        $1196adbed9371d3e$var$header.classList.add("slideUp");
    // Scrolling up
    } else {
        // header.removeClass('slideUp').addClass('slideDown');
        $1196adbed9371d3e$var$header.classList.remove("slideUp");
        $1196adbed9371d3e$var$header.classList.add("slideDown");
    }
    if (!window.showGallery && window.galleryDisappearOnNextScroll) //window.gallery.hide();
    window.galleryDisappearOnNextScroll = false;
    if (window.showGallery) {
        $1196adbed9371d3e$var$header.classList.remove("slideDown");
        $1196adbed9371d3e$var$header.classList.add("slideUp");
        window.showGallery = false;
        window.galleryDisappearOnNextScroll = true;
    }
    $1196adbed9371d3e$var$new_scroll_position = $1196adbed9371d3e$var$last_scroll_position;
}
function $1196adbed9371d3e$var$scrollTo(element) {
    window.scroll({
        behavior: 'smooth',
        left: 0,
        top: element.offsetTop
    });
}
window.scrollToElement = $1196adbed9371d3e$var$scrollTo;
window.addEventListener('scroll', $1196adbed9371d3e$var$showHideBar);
$1196adbed9371d3e$var$showHideBar(null);









window.galleries = {
    "between": (parcelRequire("jI3uq")),
    "dondevas": (parcelRequire("4ojXC")),
    "zdrowie": (parcelRequire("gkAa9")),
    "animals": (parcelRequire("hOFCO")),
    "landscape": (parcelRequire("gfs8c")),
    "else": (parcelRequire("a7vAJ"))
};


//# sourceMappingURL=scaryones.f14c3369.js.map
